import { ApolloClient, gql } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import { isLoggedIn } from '../helpers/utils';
import { cache } from './cache';
import { resolvers } from './resolvers';
import { typeDefs } from './typeDefs';
import { authUserInitialData } from './resolvers/auth';

// Define the state query for re-initialization
const RESET_STATE_QUERY = gql`
  query ResetState {
    isLoggedIn @client
    AuthUser @client
  }
`;

const httpLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/`
});

// setContext is now imported directly from @apollo/client
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token') ?? '';
  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`
    }
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  connectToDevTools: true,
  assumeImmutableResults: true,
  resolvers,
  typeDefs,
  cache
});

client.onResetStore(async () => {
  try {
    cache.writeQuery({
      query: RESET_STATE_QUERY,
      data: {
        isLoggedIn: isLoggedIn(),
        AuthUser: authUserInitialData
      }
    });
  } catch (error) {
    console.error('Error resetting store:', error);
  }
});
